const e = "styles-module__container___n2G5x", _ = "styles-module__wrapper___6xxGh", s = "styles-module__steps_container___rMLXj", t = "styles-module__footer___UQuP-", o = {
  container: e,
  wrapper: _,
  "wrapper-full-screen": "styles-module__wrapper-full-screen___KYodW",
  steps_container: s,
  footer: t
};
export {
  e as container,
  o as default,
  t as footer,
  s as steps_container,
  _ as wrapper
};
